export const cancelableCallable = <T extends (...args: never[]) => never>(
  callable: (
    controller: AbortController,
    ...args: Parameters<T>
  ) => ReturnType<T>
): {
  call: (...args: Parameters<T>) => ReturnType<T>;
  cancel: () => void;
} => {
  let controller: AbortController | undefined;
  return {
    call(...args: Parameters<T>) {
      if (controller) controller.abort();
      // отмена одноразовая, поэтому пересоздаем контроллер
      controller = new AbortController();
      return callable(controller, ...args);
    },
    cancel: () => {
      if (controller) controller.abort();
    },
  };
};
